import tw from 'tailwind-styled-components'

export const TwTitle = tw.div`
  py-8
  flex
  gap-16
`

export const TwTitleText = tw.div`
  text-sm-semibold
  text-primary
  flex
  gap-4
`

export const TwPage = tw.div`
  flex-1
  min-h-0
  flex
  flex-col
  gap-8
`
